/* import __COLOCATED_TEMPLATE__ from './classification-selector.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { createCache, getValue } from '@glimmer/tracking/primitives/cache';
import { escapeRegExp } from 'sh-www/utils/misc';

export const mapClassificationToOptions = (classification) => {
  const label = classification.label;
  const props = { key: label, classification };

  return props;
};

class ClassificationSelector extends Component {

  @tracked internalValue = '';

  #mappedClassificationsCache = createCache(() => {
    return this.args.options.map(mapClassificationToOptions);
  });

  get mappedClassifications() {
    return getValue(this.#mappedClassificationsCache);
  }

  #selectedClassificationsCache = createCache(() => {
    return this.args.selectedClassifications.map(mapClassificationToOptions);
  });

  get selectedClassifications() {
    return getValue(this.#selectedClassificationsCache);
  }

  get filteredClassifications() {
    const { internalValue, mappedClassifications } = this;

    if (!internalValue) {
      return mappedClassifications;
    }

    const escapedInternalValue = escapeRegExp(internalValue);
    const pattern = new RegExp(`(\\b${escapedInternalValue})`, 'i');

    return mappedClassifications.filter(({ key }) => {
      return pattern.test(key);
    });
  }

  @action
  handleBlur() {
    this.internalValue = '';
    this.args.onblur?.();
  }

  @action
  handleInput(value) {
    this.internalValue = value;
  }

  @action
  handleAdded({ classification }) {
    this.internalValue = '';

    const foundClassification = this.args.selectedClassifications.find((selectedClassification) => {
      return classification.id === selectedClassification.id;
    });

    if (foundClassification === undefined) {
      this.args.onadded?.(classification);
    }
  }

  @action
  handleRemoved({ classification }) {
    this.args.onremoved?.(classification);
  }
}

export default ClassificationSelector;
